import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.from-entries.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.values.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { LSPermissionNameEnum } from 'wklr-backend-sdk/models';
import { UsersApi } from 'wklr-backend-sdk/apis';
import { UsersRepository } from 'wklr-backend-sdk/repos/users';
var permissions = Object.values(LSPermissionNameEnum);
export default (/*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee(_ref, inject) {
    var app, usersApiInstance, usersRepository, me, permissionsMap;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          app = _ref.app;
          // repositoryの生成にauthの内容が必要なので、repositoryより先にこのpluginが実行されなければならず、ここで使用するrepositoryは別途生成している
          usersApiInstance = new UsersApi(undefined, '', app.$axios);
          usersRepository = new UsersRepository(usersApiInstance); // 当然、認証処理が済んでいない場合はエラーが出るが、error-handler.tsによってログイン画面に遷移される
          _context.next = 5;
          return usersRepository.getMe();
        case 5:
          me = _context.sent;
          permissionsMap = Object.fromEntries(Array.from(me.organization.permissions).map(function (p) {
            return [p, true];
          }));
          permissions.forEach(function (permission) {
            if (!permissionsMap[permission]) {
              permissionsMap[permission] = false;
            }
          });
          inject('auth', {
            user: me,
            permissions: permissionsMap
          });
        case 9:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function (_x, _x2) {
    return _ref2.apply(this, arguments);
  };
}());
export var useAuth = function useAuth() {
  var _useNuxtApp = useNuxtApp(),
    $auth = _useNuxtApp.$auth;
  return $auth;
};